import { defineStore } from 'pinia'
import { formatMap2List } from '@/utils/chat'

const useChatStore = defineStore('chat', {
    state: () => ({
        isNewchat: true, // 是否展示小智卡片
        isShowSceneCategory: false, // 是否显示场景分类
        isShowHistory: false, // 是否展示历史记录
        curSelectSession: { session_id: '' } as any,
        isSending: false, // 是否正在发送
        curUsedScene: {}, // 当前使用的场景
        controller: null,
        toSendMessage: '',
        sendBoxRef: null,
        associatSceneData: null, // 是否可以发送联想卡片请求
        intentionSubtype: 0, // 意图
        sessionList: [],
        isResponseOk: false,
        isMessageListEnd: false,
        mapping: {},
        systemResponse: {}, // 当前正在回答的问题
        isFromScene: null,
        lastResponse: {}, //
        lastQuestion: {},
        isOffline: 0, //  是否离线,1是,2否
        showScrollToBottom: true, // 消息列表是否滚动到底部
        sceneTxtExraParams: null, // 场景文本额外参数,用于不再联想
        fixed: false
    }),
    getters: {
        messageList: (state) => {
            if (Object.keys(state.mapping).length > 0) {
                return formatMap2List(state.mapping)
            } else {
                return []
            }
        },
        messageListCpt: (state) => {
            return state.messageList.filter((item) => {
                return !!item.parent_id
            })
        },

        lastMessage: (state) => {
            return state.messageList[state.messageList.length - 1] || {}
        },
        isSendBoxDisabled: (state) => {
            if (
                state.messageList.length > 0 &&
                state.messageList[state.messageList.length - 1].is_form == 1 &&
                state.messageList[state.messageList.length - 1].editCnt === 0
            ) {
                return true
            }
            return false
        }
    },
    actions: {
        updateSceneTxtExtraParams(params) {
            this.sceneTxtExraParams = params
        },
        updateShowScrollToBottom(boolean) {
            this.showScrollToBottom = boolean
        },
        updateOfflineStatus(status) {
            this.isOffline = status
        },
        updateIntentionSubtype(subtype) {
            this.intentionSubtype = subtype
        },
        updateAssociatScene(data) {
            this.associatSceneData = data
        },
        updateMessageListEnd(boolean) {
            this.isMessageListEnd = boolean
        },
        updateIsResponseOk(boolean) {
            this.isResponseOk = boolean
        },
        updateLastResponse(response) {
            this.lastResponse = response
        },
        updateLastQuestion(question) {
            this.lastQuestion = question
        },
        updateMapping(mapping) {
            this.mapping = mapping
        },
        updateFormScene(flag) {
            this.formScene = flag
        },
        updateSystemResponse(systemResponse) {
            this.systemResponse = systemResponse
        },
        updateSceneCategoryVisible(isVisible) {
            this.isShowSceneCategory = isVisible
        },
        updateMessageList(list) {
            this.messageList = list
        },
        updateCurSelectSession(session) {
            this.curSelectSession = session
        },
        updateHistory(isVisible) {
            this.isShowHistory = isVisible
        },
        updateSessionList(list) {
            this.sessionList = list
        },
        updateIsSending(isSending) {
            this.isSending = isSending
        },
        updateToSendMessage(message) {
            this.toSendMessage = message
        },
        updateIsNewChat(isVisible) {
            this.isNewchat = isVisible
        },
        updateController(controller) {
            this.controller = controller
        },
        updateCurUsedScene(scene) {
            this.curUsedScene = scene
        },
        updateFix(val) {
            this.fixed = val
        }
        // async getMessageList(sessionId) {
        //   const data = await chatApi.getMessageList({
        //     session_id: sessionId,
        //   })

        //   this.messageList = data.data.list
        // }
    }
})
export default useChatStore
